import moment from 'moment';
import momentTimeZone from 'moment-timezone';

import { CallHistory } from 'one-state-call-history';

export const range = (start: number, end: number) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
};

export const disabledDate = (current: moment.Moment): boolean => {
    // Can not select days before today and today
    return current && current <= moment().endOf('day');
};

export const disabledDateTime = ()=>  {
    return {
        disabledHours: () => range(0, 24).splice(4, 20),
        disabledMinutes: () => range(30, 60),
        disabledSeconds: () => [55, 56],
    };
};

export const disabledRangeTime = (_: any, type: string) => {
    if (type === 'start') {
        return {
        disabledHours: () => range(0, 60).splice(4, 20),
        disabledMinutes: () => range(30, 60),
        disabledSeconds: () => [55, 56],
        };
    }
    return {
        disabledHours: () => range(0, 60).splice(20, 4),
        disabledMinutes: () => range(0, 31),
        disabledSeconds: () => [55, 56],
    };
};

export const getDateWithTimezone = (d: Date, timezone: string, format?: string) => {
    if (d) {
        return momentTimeZone.tz(d, timezone).format(format);
    } else {
        return momentTimeZone.tz(new Date(), timezone).format(format);
    }
};

export const transformTimezone = (data: [CallHistory], format: string, timezone: string) => {
    if (data) {
        const result = [...data];
        result.forEach(element => {
            element.timestamp = momentTimeZone.tz(element.timestamp, format, timezone).local().format(format)
        });
        return result;
    } else {
        return [];
    }
};

function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
};

// get current time only given with time; ex: 09:59:60 => 2020-09-08 09:59:60
export const currentDateWithTimeStr = (timeStr: string, timezone: string, format?: string) => {
    const nowDate = new Date();
    const date = nowDate.getFullYear() + '-' + padTo2Digits(nowDate.getMonth()+1) + '-' + padTo2Digits(nowDate.getDate()); 
    const result = momentTimeZone.tz(`${date} ${timeStr}`, 'YYYY-MM-DD HH:mm:ss', timezone).format(format);
    return result;
};

export const toIsoString = (dateStr: string, format: string, timezone: string) => {
    const result = momentTimeZone.tz(dateStr, format, timezone).format();
    return result;
};